import { ChildbirthOBConstants } from '../store/childbirthOB.constants'

export const childbirthOBSchemas = [
  {
    inputKey: ChildbirthOBConstants.SET_FETAL_HR,
    isNumber: true,
    type: 'object',
    properties: {
      SET_FETAL_HR: {
        type: 'number',

        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_FETAL_HR'],
  },
  {
    inputKey: ChildbirthOBConstants.SET_CONTRACTIONS_FREQ,
    isNumber: true,
    type: 'object',
    properties: {
      SET_CONTRACTIONS_FREQ: {
        type: 'number',

        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_CONTRACTIONS_FREQ'],
  },
  {
    inputKey: ChildbirthOBConstants.SET_CONTRACTIONS_DUR,
    isNumber: true,
    type: 'object',
    properties: {
      SET_CONTRACTIONS_DUR: {
        type: 'number',

        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_CONTRACTIONS_DUR'],
  },
  {
    inputKey: ChildbirthOBConstants.SET_SIZE,
    isNumber: true,
    type: 'object',
    properties: {
      SET_SIZE: {
        type: 'number',

        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_SIZE'],
  },
  {
    inputKey: ChildbirthOBConstants.SET_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_DATE'],
    errorMessage: {
      properties: {
        SET_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: ChildbirthOBConstants.SET_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_TIME'],
    errorMessage: {
      properties: {
        SET_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
]

export const childbirthOBSecondsSchemas = [
  {
    inputKey: ChildbirthOBConstants.SET_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_TIME'],
    errorMessage: {
      properties: {
        SET_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
]
